import React from "react";
import ErrorBanner from "src/components/Form/ErrorBanner";
import RemoveSupplyContext from "src/context/RemoveSupplyContext";

export const AlertBannerSection = () => {
  const { displayingAlertBanner, setDisplayingAlertBanner } =
    React.useContext(RemoveSupplyContext);

  return (
    <ErrorBanner
      errorType={displayingAlertBanner}
      onClose={setDisplayingAlertBanner}
      alertBannerProps={{
        fluidity: false,
      }}
    />
  );
};
